import contextChannelIdLink from "@magalu/ecomm-components/rave/apollo/contextChannelIdLink";
import errorLink from "@magalu/ecomm-components/rave/apollo/errorLink";

import { channelConfig } from "./channelConfig";

export const middlewares = [
  errorLink("mixer-web", ["suggestQuery"]),
  channelConfig,
  contextChannelIdLink({ isMiniApp: false }),
];
